import { Component, OnInit, NgZone, Inject, EventEmitter, ViewChild } from '@angular/core';

@Component({
    selector: 'overlay',
    template: ``
})  
export class Overlay{

    public ngAfterContentInit() {        
        this.setBodyOverflowY('hidden');
        this.setGlobalWarapperMobileStyle('hidden', '99vh');
    }

    public ngOnDestroy() {
        this.setBodyOverflowY('auto');
        this.setGlobalWarapperMobileStyle('auto', 'auto');
    }

    public isMobile() {
        return window.innerWidth <= 767;
    }

    private setBodyOverflowY(overflow: string) {
        const body = document.querySelector('body');

        if (body && body.style) {
            body.style.overflowY = overflow;
        }
    }

    private setGlobalWarapperMobileStyle(overflowY: string, height: string) {
        const globalWrapper = <HTMLElement>document.querySelector('.global-wrapper');

        if (globalWrapper && globalWrapper.style && this.isMobile()) {
            globalWrapper.style.height = height;
            globalWrapper.style.overflowY = overflowY;
        }
    }
}